import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { classMap } from 'lit/directives/class-map.js'
import { customElement, property } from 'lit/decorators.js'
import { style } from './breadcrumb-item.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'


initializeIconsByRole({
  'cse-breadcrumb-item.home': { name: 'house', style: 'solid' },
})

export const breadcrumbItemVariants = ['current', 'default', 'home'] as const
export type breadcrumbItemVariantTypes = typeof breadcrumbItemVariants

@customElement('cse-breadcrumb-item')
export class CSEBreadcrumbItem extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  @property({ type: String })
  variant: breadcrumbItemVariantTypes[number] = 'default'

  @property({ type: String })
  url: string = ''

  private classes = () => classMap({
    'cse-breadcrumb-item': true,
    'font-body-s': true,
    [`variant-${this.variant}`]: true,
  })

  private renderCurrentBreadcrumb = () => html`
    <span class="${this.classes()}" aria-current="page">
      <slot></slot>
    </span>
  `

  private renderDefaultBreadcrumb = () => html`
    <a class="${this.classes()}" href="${this.url}">
      ${this.variant === 'home'
        ? html`<cse-icon icon-role="cse-breadcrumb-item.home"></cse-icon>`
        : nothing
      }
      <slot></slot>
    </a>
  `

  override render() {
    if (this.variant === 'current') {
      return this.renderCurrentBreadcrumb()
    } else {
      return this.renderDefaultBreadcrumb()
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-breadcrumb-item': CSEBreadcrumbItem
  }
}
